export type ActionButtonTheme = 'white' | 'green' | 'green-outlined' | 'navy';
